import {
  Card,
  CardBody,
  Button,
  Container,
  Col,
  Row,
  CardFooter,
  Stack,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
// import { LOGIN, SETTINGS, LOANDUES } from "../../services/actions";
import { SignOut, Warning } from "@phosphor-icons/react";
import { useNavigate } from "react-router-dom";

import Footer from "../pages/public_payment/Footer";
import React from "react";
import paymentImage from "../pages/public_payment/payhuman.png";
import PwaInstallPrompt from "../components/PwaInstallPrompt";

export default function AppLayout({ children }) {
  // ========================================
  // HOOKS AND STATE INITIALIZATION
  // ========================================
  let dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit, control } = useForm({
    defaultValues: { username: "admin@gmail.com", password: "Admin@123" },
    mode: "all",
  });

  // ========================================
  // STATE MANAGEMENT
  // ========================================
  const [main, setMain] = React.useState();
  const [loans, setLoans] = React.useState();
  const [selectedLoans, setSelectedLoans] = React.useState(null);
  const [toggle, setToggle] = React.useState(0);

  // ========================================
  // REDUX SELECTORS
  // ========================================
  let loanState = useSelector((state) => state?.loanduesState);
  let userState = useSelector((state) => state?.login);
  let settingsState = useSelector((state) => state?.settingsState);

  // ========================================
  // UTILITY FUNCTIONS
  // ========================================
  const handlePayment = (payAmount) => {
    console.log("Payment initiated for amount:", payAmount);
  };

  // ========================================
  // EFFECTS - Data Fetching and Updates
  // ========================================

  // Effect for fetching initial data (commented out - uncomment when services are available)
  // React.useEffect(() => {
  //   try {
  //     let user = JSON.parse(localStorage.getItem("data") || "{}");
  //     dispatch({
  //       type: `${LOANDUES}_GET`,
  //       payload: user.customerID,
  //     });
  //     dispatch({ type: `${SETTINGS}_GET`, payload: 1 });
  //   } catch (err) {
  //     console.error("Error fetching initial data:", err);
  //   }
  // }, [dispatch]);

  // Effect for updating loans state
  React.useEffect(() => {
    setLoans(loanState?.data?.data);
    console.log("LOANS:", loanState);
  }, [loanState?.data]);

  // Effect for updating main settings
  React.useEffect(() => {
    try {
      let mainStr = settingsState?.data?.data?.main;
      let mainData = typeof mainStr === "string" ? JSON.parse(mainStr) : mainStr;
      setMain(mainData);
      
      // Cache settings in localStorage for offline access
      if (mainData) {
        localStorage.setItem("settings", JSON.stringify(mainData));
      }
    } catch (err) {
      console.error("Error processing settings:", err);
      // Fallback to cached settings if available
      try {
        const cachedSettings = localStorage.getItem("settings");
        if (cachedSettings) {
          setMain(JSON.parse(cachedSettings));
        }
      } catch (cacheErr) {
        console.error("Error loading cached settings:", cacheErr);
      }
    }
  }, [settingsState]);

  return (
    <>
      {/* ========================================
          MAIN CONTAINER - Full height layout
          ======================================== */}
      <Container
        fluid
        className="g-0 w-100 vh-100"
        style={{ 
          backgroundColor: "rgba(255, 255, 255, 0.8)",
          overflow: "hidden" // Prevent body scroll
        }}
      >
        {/* ========================================
            TWO COLUMN LAYOUT ROW
            ======================================== */}
        <Row
          className="g-0 d-flex h-100 "
          style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
        >
          
          {/* ========================================
              LEFT COLUMN - Main Content Area
              ======================================== */}
          <Col
            xs={12}
            md={6}
            className="d-flex flex-column"
            style={{
              height: "100vh",
              overflowY: "auto",
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE & Edge
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              position: "relative", // For proper footer positioning
            }}
          >
            {/* Hide scrollbar for webkit browsers */}
            <style jsx>{`
              .left-content::-webkit-scrollbar {
                display: none;
              }
            `}</style>
            
            {/* Main content area - flexible height */}
            <div className="flex-grow-1 pb-5">
              {children}
              
            </div>
 <PwaInstallPrompt />
            {/* ========================================
                MOBILE FOOTER - Only visible on mobile
                ======================================== */}
            <div className="d-md-none mt-auto">
              <Footer />
            </div>
          </Col>

          {/* ========================================
              RIGHT COLUMN - Brand/Image Section (Desktop Only)
              ======================================== */}
          <Col
            md={6}
            className="d-none d-md-flex flex-column align-items-center justify-content-between"
            style={{
              position: "fixed",
              right: 0,
              top: 0,
              height: "100vh",
              width: "50vw",
              backgroundColor: "rgba(246, 246, 246, 0.8)",
              zIndex: 1,
            }}
          >
            {/* Company Logo Section */}
            <Container className="d-flex justify-content-end pt-4">
              {main?.icon && (
                <img
                  src={main.icon}
                  alt="Company Logo"
                  style={{
                    height: "60px",
                    width: "300px",
                    objectFit: "contain",
                  }}
                />
              )}
            </Container>

            {/* Main Image Section */}
            <Container
              className="d-flex align-items-center justify-content-center flex-grow-1"
              style={{
                maxHeight: "70vh",
                overflow: "hidden",
              }}
            >
              <img
                src={paymentImage}
                alt="Payment Illustration"
                className="img-fluid"
                style={{
                  width: "100%",
                  height: "auto",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            </Container>
</Col>
            {/* ========================================
                DESKTOP FOOTER - Only visible on desktop
                ======================================== */}
               
            <footer
               className=" d-none d-sm-block d-flex box-footer text-center text-center mt-3 w-100  position-fixed  position-md-static "
           style={{
            bottom: 0, // Required for position-fixed
            width: "100%",
            bottom: 0,
            borderTop: "2px solid black",
            // height: 75,
            zIndex: 1000, // Ensure it stays on top
          }}
            >
              <div className=" d-flex justify-content-center mb-2   ">
                <div className="d-flex justify-content-center mb-2">
                  <small className="text-muted me-2">
                    © All Rights Reserved
                  </small>
                  <small className="text-muted">
                    Powered by{" "}
                    <span 
                      style={{ 
                        fontStyle: "italic",
                        fontWeight: "600",
                        color: "#007bff"
                      }}
                    >
                      icrats
                    </span>
                  </small>
                </div>
              </div>
            </footer>
          
        </Row>
      </Container>

      {/* ========================================
          PWA INSTALL PROMPT (if component exists)
          ======================================== */}
     
    </>
  );
}

// ========================================
// COMPONENT NOTES AND ARCHITECTURE:
// ========================================

/*
LAYOUT STRUCTURE:
1. Full-height container with two-column responsive layout
2. Left column (xs=12, md=6): Main content area with children
3. Right column (md=6): Brand section with logo and illustration (desktop only)

RESPONSIVE BEHAVIOR:
- Mobile (xs): Single column, mobile footer at bottom
- Desktop (md+): Two columns with fixed right panel and desktop footer

FOOTER IMPLEMENTATION:
- Mobile: Uses imported Footer component, positioned at bottom of left column
- Desktop: Custom inline footer in right column with company branding

KEY FEATURES:
- Proper scroll handling with hidden scrollbars
- Fixed right panel on desktop for consistent branding
- Responsive image handling with proper aspect ratios
- Error handling for settings and cached data
- Clean separation of concerns with organized code sections

IMPROVEMENTS MADE:
1. Added comprehensive commenting and organization
2. Fixed layout structure and responsive behavior
3. Proper footer implementation for mobile/desktop
4. Enhanced error handling and fallbacks
5. Better spacing and visual hierarchy
6. Proper z-index management for fixed elements
7. Semantic HTML structure with accessibility considerations
*/